{
  "___TODO": "borre esto de los textos no utilizados",
  "title": "Crear subcuenta",
  "next": "Siguiente",
  "finish": "Finalizar",
  "back": "Atrás",
  "selectAccount": "Seleccione una cuenta",
  "topics": {
    "selectAccount": "Seleccionar cuenta",
    "createAccount": "Crear cuenta",
    "createSubAccount": "Crear subcuenta",
    "subAccountSummary": "Resumen de subcuentas"
  },
  "inherited": " - (heredado)",
  "subAccountSummary": {
    "added": "Ha añadido correctamente una nueva subcuenta",
    "failed": "No se ha podido añadir una nueva subcuenta.",
    "subAccMsg": "Conectemos esta meta a una subcuenta",
    "subAccountSubTitle": "Ha creado correctamente una subcuenta",
    "name": "Nombre",
    "portfolioTheme": "Tema de la cartera",
    "Portfolio": "Cartera",
    "requireIPS": "Se requiere una declaración de política de inversión",
    "allowClientDeposit": "Permitir depósitos de clientes",
    "allowFractionalShare": "Permitir acciones fraccionadas"
  },
  "theyHaveActiveAccounts_one": "Esta {{entity}} tiene actualmente {{count}} cuentas activas.",
  "theyHaveActiveAccounts_other": "Esta {{entity}} tiene actualmente {{count}} cuentas activas.",
  "client": "cliente",
  "household": "hogar",
  "corporation": "empresa",
  "useExistingOrCreateNew": "¿Desea utilizar una cuenta existente para su subcuenta o crear una nueva?",
  "createAccountFirst": "Por favor, cree primero una nueva cuenta.",
  "actions": {
    "useExsistingAccount": "Usar cuenta existente",
    "createNewAccount": "Crear nueva cuenta",
    "createSubAccount": "Crear subcuenta",
    "reviewDocuments": "Revisar documentos",
    "goToSubaccount": "Ir a subcuenta",
    "almost": "Casi terminado.",
    "next": "Siguiente"
  }
}
